// components/Loader/LoaderContext.js
import {createContext, useContext} from "react";

export const LoaderContext = createContext({
  showLoader: () => {},
  hideLoader: () => {},
});

export const useLoader = () => useContext(LoaderContext);
